<template>
  <vbt-content-box v-bind="$attrs">
    <template #title>
      <v-layout align-center>
        <strong class="green--text">
          #{{ $route.params.id }}
        </strong>
        <kernel-status-badge
          v-show="!$attrs.loading"
          :status="pressSheetStatusEnumByValue[pressSheet.status]"
          class="ml-2"
        >
          {{ pressSheet.status }}
        </kernel-status-badge>
      </v-layout>
    </template>
    <v-layout
      :class="$_themeTextColorClass"
      class="mt-2"
    >
      <v-flex lg4>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Substrate:
          </strong>
          {{ pressSheet.substrate }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Created date:
          </strong>
          {{ formatDate(pressSheet.created) }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Expires date:
          </strong>
          {{ formatDate(pressSheet.expires) }}
        </v-layout>
      </v-flex>
      <v-flex lg4>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Priority:
          </strong>
          {{ pressSheet.priority }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Run Count:
          </strong>
          {{ pressSheet.quantity }}
        </v-layout>
      </v-flex>
      <v-flex lg4>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Sides:
          </strong>
          {{ pressSheet.sides }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            UV Back:
          </strong>
          {{ pressSheet.uvBack }}
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            UV Front:
          </strong>
          {{ pressSheet.uvFront }}
        </v-layout>
      </v-flex>
    </v-layout>
  </vbt-content-box>
</template>

<script>

import { mapGetters } from 'vuex';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';

import { formatDate } from '@helpers';

import { provideThemeSettings } from '@mixins';

export default {
  name: 'KernelPressSheetInfoView',
  mixins: [
    provideThemeSettings,
  ],
  props: {
    pressSheet: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(EnumsNamespace, ['pressSheetStatusEnumByValue']),
  },
  methods: {
    formatDate,
  },
};
</script>
